export default "__VITE_ASSET__bfa527b0__"